import { Flex, FormLabel, Text } from "@chakra-ui/react";


interface StandInfoProps {
    label: string;
    value?: string;
}

export function StandInfo({ label, value }: StandInfoProps) {
    return(
        <Flex 
            w="100%" 
            direction="column"
        > 
            {label && (
                <FormLabel
                    w="100%"
                    color="black"
                    fontSize="16px"
                >
                    {label}
                </FormLabel>
            )}
            <Text 
                fontWeight={700} 
                fontSize="14px"
                color="black"
                font-variant-numeric="normal"
            >
                {value}
            </Text>
        </Flex>
    )
}